var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0C5.811 0 0 5.811 0 13C0 20.189 5.811 26 13 26C20.189 26 26 20.189 26 13C26 5.811 20.189 0 13 0ZM19.5 17.667L17.667 19.5L13 14.833L8.333 19.5L6.5 17.667L11.167 13L6.5 8.333L8.333 6.5L13 11.167L17.667 6.5L19.5 8.333L14.833 13L19.5 17.667Z",
    fill: "#F03E39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/icon7.a14e38e359de5bcdec00200150c10a20.svg";
export { ForwardRef as ReactComponent };